import React, { useState, useEffect } from "react";

const BankToBankTransfer = () => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    date: "",
    fromBank: "",
    toBank: "",
    amount: "",
    paymentMode: "",
    depositName: "",
    reason: ""
  });

  const [records, setRecords] = useState(() => {
    const savedRecords = localStorage.getItem("grampanchayat_bank_transfer");
    return savedRecords ? JSON.parse(savedRecords) : [];
  });

  // Save to localStorage
  useEffect(() => {
    localStorage.setItem("grampanchayat_bank_transfer", JSON.stringify(records));
  }, [records]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.date || !formData.fromBank || !formData.toBank || !formData.amount || !formData.paymentMode || !formData.depositName || !formData.reason) {
      alert("❌ कृपया सर्व आवश्यक माहिती भरा!");
      return;
    }

    setRecords([...records, { ...formData, id: Date.now() }]);

    setFormData({
      date: "",
      fromBank: "",
      toBank: "",
      amount: "",
      paymentMode: "",
      depositName: "",
      reason: ""
    });

    alert("✅ बँकेतून बँकेत पैसे भरणे यशस्वीरित्या जोडले गेले!");
    setShowForm(false);
  };

  const handleDelete = (id) => {
    const updated = records.filter((record) => record.id !== id);
    setRecords(updated);
  };

  const handleReset = () => {
    setFormData({
      date: "",
      fromBank: "",
      toBank: "",
      amount: "",
      paymentMode: "",
      depositName: "",
      reason: ""
    });
  };

  return (
    <div className="transfer-container" style={{ 
      marginTop: "2rem", 
      padding: "1rem",
      backgroundColor: "#f8f9fa",
      borderRadius: "0.5rem",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    }}>

      {/* HEADER WITH TOGGLE */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "1.5rem",
        backgroundColor: "linear-gradient(135deg, #003366 0%, #004d99 100%)",
        backgroundImage: "linear-gradient(135deg, #003366 0%, #004d99 100%)",
        color: "white",
        padding: "1.2rem 1.5rem",
        borderRadius: "0.5rem",
        boxShadow: "0 4px 6px rgba(0,0,0,0.15)"
      }}>
        <div>
          <h3 style={{ margin: 0, fontSize: "1.4rem", fontWeight: "700", letterSpacing: "0.5px" }}>
            💸 बँकेतून बँकेत पैसे भरणे
          </h3>
          <p style={{ margin: "0.25rem 0 0 0", fontSize: "0.9rem", opacity: 0.9 }}>
            बँक खाते दरम्यान निधी हस्तांतरण व्यवस्थापन करा
          </p>
        </div>
        <button
          onClick={() => setShowForm(!showForm)}
          style={{
            backgroundColor: showForm ? "#dc3545" : "#28a745",
            color: "white",
            border: "none",
            padding: "0.7rem 1.5rem",
            borderRadius: "25px",
            cursor: "pointer",
            fontSize: "0.95rem",
            fontWeight: "600",
            transition: "all 0.3s ease",
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            transform: "translateY(0)"
          }}
          onMouseOver={(e) => {
            e.target.style.transform = "translateY(-2px)";
            e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.3)";
          }}
          onMouseOut={(e) => {
            e.target.style.transform = "translateY(0)";
            e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.2)";
          }}
        >
          {showForm ? "✕ बंद करा" : "➕ नवीन नोंद"}
        </button>
      </div>

      {/* FORM SECTION */}
      {showForm && (
        <div className="transfer-form-card" style={{
          backgroundColor: "white",
          padding: "2rem",
          marginBottom: "2rem",
          borderRadius: "0.75rem",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          border: "1px solid #e9ecef"
        }}>
          <form onSubmit={handleSubmit}>
            <div className="row g-3">

              <div className="col-md-6">
                <label className="form-label" style={{
                  fontWeight: "600",
                  color: "#003366",
                  marginBottom: "0.5rem",
                  fontSize: "0.95rem"
                }}>
                  📅 दिनांक <span style={{ color: "#dc3545" }}>*</span>
                </label>
                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  className="form-control"
                  required
                  style={{
                    padding: "0.75rem",
                    border: "2px solid #e9ecef",
                    borderRadius: "0.4rem",
                    fontSize: "0.95rem",
                    transition: "border-color 0.3s"
                  }}
                  onFocus={(e) => e.target.style.borderColor = "#003366"}
                  onBlur={(e) => e.target.style.borderColor = "#e9ecef"}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label" style={{
                  fontWeight: "600",
                  color: "#003366",
                  marginBottom: "0.5rem",
                  fontSize: "0.95rem"
                }}>
                  💳 पेमेंट पद्धत <span style={{ color: "#dc3545" }}>*</span>
                </label>
                <select
                  name="paymentMode"
                  value={formData.paymentMode}
                  onChange={handleChange}
                  className="form-select"
                  required
                  style={{
                    padding: "0.75rem",
                    border: "2px solid #e9ecef",
                    borderRadius: "0.4rem",
                    fontSize: "0.95rem",
                    transition: "border-color 0.3s"
                  }}
                  onFocus={(e) => e.target.style.borderColor = "#003366"}
                  onBlur={(e) => e.target.style.borderColor = "#e9ecef"}
                >
                  <option value="">-- निवडा --</option>
                  <option>Cheque</option>
                  <option>NEFT</option>
                  <option>RTGS</option>
                  <option>UPI</option>
                  <option>अन्य</option>
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label" style={{
                  fontWeight: "600",
                  color: "#003366",
                  marginBottom: "0.5rem",
                  fontSize: "0.95rem"
                }}>
                  🏦 पैसे काढलेल्या बँकेचे नाव <span style={{ color: "#dc3545" }}>*</span>
                </label>
                <select
                  name="fromBank"
                  value={formData.fromBank}
                  onChange={handleChange}
                  className="form-select"
                  required
                  style={{
                    padding: "0.75rem",
                    border: "2px solid #e9ecef",
                    borderRadius: "0.4rem",
                    fontSize: "0.95rem",
                    transition: "border-color 0.3s"
                  }}
                  onFocus={(e) => e.target.style.borderColor = "#003366"}
                  onBlur={(e) => e.target.style.borderColor = "#e9ecef"}
                >
                  <option value="">-- निवडा --</option>
                  <option>State Bank of India</option>
                  <option>HDFC बँक</option>
                  <option>ICICI बँक</option>
                  <option>Bank of Maharashtra</option>
                  <option>Axis बँक</option>
                  <option>अन्य</option>
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label" style={{
                  fontWeight: "600",
                  color: "#003366",
                  marginBottom: "0.5rem",
                  fontSize: "0.95rem"
                }}>
                  🏦 पैसे भरलेल्या बँकेचे नाव <span style={{ color: "#dc3545" }}>*</span>
                </label>
                <select
                  name="toBank"
                  value={formData.toBank}
                  onChange={handleChange}
                  className="form-select"
                  required
                  style={{
                    padding: "0.75rem",
                    border: "2px solid #e9ecef",
                    borderRadius: "0.4rem",
                    fontSize: "0.95rem",
                    transition: "border-color 0.3s"
                  }}
                  onFocus={(e) => e.target.style.borderColor = "#003366"}
                  onBlur={(e) => e.target.style.borderColor = "#e9ecef"}
                >
                  <option value="">-- निवडा --</option>
                  <option>State Bank of India</option>
                  <option>HDFC बँक</option>
                  <option>ICICI बँक</option>
                  <option>Bank of Maharashtra</option>
                  <option>Axis बँक</option>
                  <option>अन्य</option>
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label" style={{
                  fontWeight: "600",
                  color: "#003366",
                  marginBottom: "0.5rem",
                  fontSize: "0.95rem"
                }}>
                  💰 रक्कम (₹) <span style={{ color: "#dc3545" }}>*</span>
                </label>
                <input
                  type="number"
                  name="amount"
                  value={formData.amount}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="0.00"
                  step="0.01"
                  required
                  style={{
                    padding: "0.75rem",
                    border: "2px solid #e9ecef",
                    borderRadius: "0.4rem",
                    fontSize: "0.95rem",
                    transition: "border-color 0.3s"
                  }}
                  onFocus={(e) => e.target.style.borderColor = "#28a745"}
                  onBlur={(e) => e.target.style.borderColor = "#e9ecef"}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label" style={{
                  fontWeight: "600",
                  color: "#003366",
                  marginBottom: "0.5rem",
                  fontSize: "0.95rem"
                }}>
                  👤 जमा करण्याचे नाव <span style={{ color: "#dc3545" }}>*</span>
                </label>
                <input
                  type="text"
                  name="depositName"
                  value={formData.depositName}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="नाव टाका"
                  required
                  style={{
                    padding: "0.75rem",
                    border: "2px solid #e9ecef",
                    borderRadius: "0.4rem",
                    fontSize: "0.95rem",
                    transition: "border-color 0.3s"
                  }}
                  onFocus={(e) => e.target.style.borderColor = "#003366"}
                  onBlur={(e) => e.target.style.borderColor = "#e9ecef"}
                />
              </div>

              <div className="col-12">
                <label className="form-label" style={{
                  fontWeight: "600",
                  color: "#003366",
                  marginBottom: "0.5rem",
                  fontSize: "0.95rem"
                }}>
                  📝 कारण/विवरण <span style={{ color: "#dc3545" }}>*</span>
                </label>
                <textarea
                  name="reason"
                  value={formData.reason}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="कारण लिहा"
                  rows="3"
                  required
                  style={{
                    padding: "0.75rem",
                    border: "2px solid #e9ecef",
                    borderRadius: "0.4rem",
                    fontSize: "0.95rem",
                    resize: "vertical",
                    transition: "border-color 0.3s",
                    fontFamily: "inherit"
                  }}
                  onFocus={(e) => e.target.style.borderColor = "#003366"}
                  onBlur={(e) => e.target.style.borderColor = "#e9ecef"}
                />
              </div>

            </div>

            <div className="text-center mt-4" style={{ display: "flex", gap: "1rem", justifyContent: "center" }}>
              <button
                className="btn btn-success px-4"
                type="submit"
                style={{
                  padding: "0.75rem 1.5rem",
                  fontSize: "0.95rem",
                  fontWeight: "600",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: "#28a745",
                  boxShadow: "0 2px 4px rgba(40, 167, 69, 0.3)",
                  transition: "all 0.3s",
                  cursor: "pointer"
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = "#218838";
                  e.target.style.boxShadow = "0 4px 8px rgba(40, 167, 69, 0.5)";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = "#28a745";
                  e.target.style.boxShadow = "0 2px 4px rgba(40, 167, 69, 0.3)";
                }}
              >
                💾 जतन करा
              </button>
              <button
                className="btn btn-secondary px-4"
                type="button"
                onClick={handleReset}
                style={{
                  padding: "0.75rem 1.5rem",
                  fontSize: "0.95rem",
                  fontWeight: "600",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: "#6c757d",
                  boxShadow: "0 2px 4px rgba(108, 117, 125, 0.3)",
                  transition: "all 0.3s",
                  cursor: "pointer"
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = "#5a6268";
                  e.target.style.boxShadow = "0 4px 8px rgba(108, 117, 125, 0.5)";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = "#6c757d";
                  e.target.style.boxShadow = "0 2px 4px rgba(108, 117, 125, 0.3)";
                }}
              >
                🔄 रीसेट करा
              </button>
            </div>
          </form>
        </div>
      )}

      {/* TABLE SECTION */}
      <div className="transfer-table-card" style={{
        backgroundColor: "white",
        borderRadius: "0.75rem",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        overflow: "hidden",
        border: "1px solid #e9ecef"
      }}>
        <div style={{
          backgroundColor: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
          backgroundImage: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
          padding: "1.2rem",
          borderBottom: "2px solid #dee2e6",
          fontWeight: "700",
          fontSize: "1.1rem",
          color: "#003366",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}>
          <div>📋 बँकेतून बँकेत पैसे भरणे यादी</div>
          <div style={{
            backgroundColor: "#003366",
            color: "white",
            padding: "0.4rem 0.8rem",
            borderRadius: "20px",
            fontSize: "0.85rem",
            fontWeight: "600"
          }}>
            एकूण: {records.length}
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-hover mb-0" style={{ marginBottom: 0 }}>
            <thead style={{ backgroundColor: "#f1f3f5" }}>
              <tr>
                <th style={{ 
                  width: "5%", 
                  color: "#003366", 
                  fontWeight: "700",
                  padding: "1rem"
                }}>क्र.</th>
                <th style={{ color: "#003366", fontWeight: "700", padding: "1rem" }}>दिनांक</th>
                <th style={{ color: "#003366", fontWeight: "700", padding: "1rem" }}>काढलेली बँक</th>
                <th style={{ color: "#003366", fontWeight: "700", padding: "1rem" }}>भरलेली बँक</th>
                <th style={{ color: "#003366", fontWeight: "700", padding: "1rem" }}>पेमेंट</th>
                <th style={{ color: "#003366", fontWeight: "700", padding: "1rem" }}>रक्कम</th>
                <th style={{ color: "#003366", fontWeight: "700", padding: "1rem" }}>जमा नाव</th>
                <th style={{ color: "#003366", fontWeight: "700", padding: "1rem" }}>कारण</th>
                <th style={{ 
                  width: "10%", 
                  color: "#003366", 
                  fontWeight: "700",
                  padding: "1rem"
                }}>क्रिया</th>
              </tr>
            </thead>
            <tbody>
              {records.length === 0 ? (
                <tr>
                  <td colSpan="9" style={{ 
                    padding: "3rem 2rem", 
                    textAlign: "center",
                    color: "#6c757d",
                    fontSize: "1rem",
                    fontWeight: "500"
                  }}>
                    📭 कोणतीही नोंद उपलब्ध नाही
                  </td>
                </tr>
              ) : (
                records.map((row, index) => (
                  <tr key={row.id} style={{
                    borderBottom: "1px solid #e9ecef",
                    transition: "background-color 0.2s"
                  }}
                  onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#f8f9fa"}
                  onMouseOut={(e) => e.currentTarget.style.backgroundColor = "white"}
                  >
                    <td style={{ padding: "1rem", fontWeight: "600", color: "#003366" }}>{index + 1}</td>
                    <td style={{ padding: "1rem" }}>{row.date}</td>
                    <td style={{ padding: "1rem" }}>{row.fromBank}</td>
                    <td style={{ padding: "1rem" }}>{row.toBank}</td>
                    <td style={{ padding: "1rem" }}>
                      <span style={{
                        backgroundColor: "#e3f2fd",
                        color: "#1976d2",
                        padding: "0.3rem 0.6rem",
                        borderRadius: "12px",
                        fontSize: "0.85rem",
                        fontWeight: "500"
                      }}>
                        {row.paymentMode}
                      </span>
                    </td>
                    <td style={{ 
                      textAlign: "right", 
                      padding: "1rem",
                      fontWeight: "600",
                      color: "#28a745"
                    }}>
                      ₹ {parseFloat(row.amount || 0).toFixed(2)}
                    </td>
                    <td style={{ padding: "1rem" }}>{row.depositName || "-"}</td>
                    <td style={{ padding: "1rem", color: "#666", fontSize: "0.9rem" }}>
                      {row.reason ? (
                        <span title={row.reason}>
                          {row.reason.substring(0, 15)}...
                        </span>
                      ) : "-"}
                    </td>
                    <td style={{ padding: "1rem" }}>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(row.id)}
                        style={{ 
                          width: "100%",
                          padding: "0.5rem",
                          fontSize: "0.85rem",
                          borderRadius: "4px",
                          backgroundColor: "#dc3545",
                          border: "none",
                          color: "white",
                          cursor: "pointer",
                          transition: "all 0.2s"
                        }}
                        onMouseOver={(e) => {
                          e.target.style.backgroundColor = "#c82333";
                          e.target.style.boxShadow = "0 2px 4px rgba(220, 53, 69, 0.3)";
                        }}
                        onMouseOut={(e) => {
                          e.target.style.backgroundColor = "#dc3545";
                          e.target.style.boxShadow = "none";
                        }}
                      >
                        🗑️ हटवा
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

    </div>
  );
};

export default BankToBankTransfer;
